import { HTMLProps } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import clsx from 'classnames'
import { useAppearance } from '@/shared/utils'

import { AnalyticCard } from '@/entities/analytic-card'
import type { IPostPreview } from '@/interfaces/analytics'
import style from './analytics-list.module.scss'

type AnalyticsListProps = HTMLProps<HTMLDivElement> & {
  cards: Omit<IPostPreview, 'blocks'>[]
  publications?: boolean
}

export const AnalyticsList = (props: AnalyticsListProps) => {
  const { cards, publications } = props
  const { ref: cardsRef, animate: cardsAnimate } = useAppearance()

  return (
    <motion.ul ref={cardsRef} animate={cardsAnimate} className={style.list}>
      <AnimatePresence mode="popLayout">
        {cards?.map(({ category, slug, date_published, title, image_preview, type, external_url }, index) => (
          <AnalyticCard
            className={clsx(style.item, { [style.publications]: publications })}
            key={index}
            title={title}
            date={date_published}
            category={category}
            image={image_preview}
            index={index}
            slug={slug}
            type={type}
            external_url={external_url}
          />
        ))}
      </AnimatePresence>
    </motion.ul>
  )
}
